import React from 'react';
import { SGSButton, SGSFormInput } from 'components';
import { FormProvider, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import { RubriqueForm, RubriqueType } from 'core/models';
import { FormProps, isCreation, SGSForm } from 'components/Form';
import { useHistory } from 'react-router';

type Props = FormProps<RubriqueForm>;

const FAQRubriqueForm: React.FC<Props> = ({ defaultValues = {}, ...props }) => {
    const { t } = useTranslation();
    const isCreate = isCreation(props);
    const history = useHistory();
    const onSubmit = isCreate ? props.onCreate : props.onEdit;
    const validationSchema: Yup.SchemaOf<RubriqueForm> = Yup.object().shape({
        name: Yup.string().required(),
        order: Yup.number().required(),
        type: Yup.mixed<RubriqueType>().oneOf(['article', 'decrypt', 'faq', 'tuto']).required(),
    });

    const methods = useForm<RubriqueForm>({
        resolver: yupResolver(validationSchema),
        defaultValues,
    });
    const { handleSubmit } = methods;

    return (
        <FormProvider {...methods}>
            <SGSForm.Card onSubmit={handleSubmit(onSubmit)}>
                <SGSForm.Row>
                    <SGSForm.Col>
                        <SGSFormInput variant="outlined" name="name" label="rubrique.title" />
                        <SGSFormInput variant="outlined" name="order" label="rubrique.order" type="number" />
                    </SGSForm.Col>
                </SGSForm.Row>
                <SGSForm.Actions>
                    <SGSButton
                        variant="outlined"
                        className="mr-2"
                        onClick={() => {
                            history.push('/faq/rubriques');
                        }}
                    >
                        {t('global.back')}
                    </SGSButton>
                    <SGSButton type="submit">{isCreate ? t('global.create') : t('global.save')}</SGSButton>
                </SGSForm.Actions>
            </SGSForm.Card>
        </FormProvider>
    );
};

export default FAQRubriqueForm;
